import profileUrl from './profileUrl';

export default function filterProfileUrl(url, name) {
  if (!url) return '/';
  const filtered = url
    .replace('http://www.localsearch.com.au', '')
    .replace('https://www.localsearch.com.au', '');
  const parts = filtered.split('/');

  if (parts.length > 5) {
    return profileUrl(
      {
        name,
        suburb_url: parts[4],
        hash: parts[5],
      },
      true
    );
  }

  return profileUrl(filtered, true);
}
